// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Autocomplete from 'react-autocomplete';

const StyledWrapper = styled.div`
  > div {
    width: 100%;
  }
`;

const StyledOptionsContainer = styled.div`
  border: 1px solid #ccc;
  padding: 9px 6px;
  z-index: 9000;
`;

const StyledOption = styled.div`
  padding: 8px;
  cursor: pointer;
  background: ${props => (props.isHighlighted ? 'lightgray' : 'white')};
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const CustomAutoComplete = ({ items, onSelect, initialValue }) => {
  const [inputVal, setInputVal] = useState('');

  useEffect(() => {
    if (!initialValue) return;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    const val = items.find(i => i.value === initialValue);
    if (val) setInputVal(val.label);
  }, []);

  const renderMenu = data => (
    <StyledOptionsContainer>{data}</StyledOptionsContainer>
  );

  const onSelectOption = value => {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    const label = items.find(i => i.value === value)?.label;
    setInputVal(label);
    onSelect(value);
  };

  return (
    <StyledWrapper>
      <Autocomplete
        items={items}
        getItemValue={item => item.value}
        renderItem={(item, isHighlighted) => (
          <StyledOption isHighlighted={isHighlighted} key={item.value}>
            {item.label}
          </StyledOption>
        )}
        value={inputVal}
        onChange={e => setInputVal(e.target.value)}
        onSelect={onSelectOption}
        inputProps={{
          placeholder: 'Start typing activity name',
          className: 'form-control',
        }}
        renderMenu={renderMenu}
        shouldItemRender={(item, value) =>
          item.label.toLowerCase().indexOf(value.toLowerCase()) > -1
        }
      />
    </StyledWrapper>
  );
};

export default CustomAutoComplete;
